import { Component, input, OnInit, output, signal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UrlConfig } from '../../../types';

@Component({
  selector: 'app-suspect-image',
  templateUrl: './suspect-image.component.html',
  styleUrls: ['./suspect-image.component.scss'],
  standalone: false,
})
export class SuspectImageComponent implements OnInit {
  public cancellationId = input<string>('');

  public hasKioskPhoto = output<boolean>();

  readonly urlConfigs: ReadonlyArray<UrlConfig> = environment.suspectImageUrlConfigs;

  url = signal<string | null>(null);
  urlId = signal<number>(0);

  imageLoaded = signal<boolean>(false);
  imageNotFound = signal<boolean>(false);

  ngOnInit() {
    this.url.set(null);
    this.urlId.set(0);
    this.buildUrl();
  }

  buildUrl() {
    if (this.urlId() >= this.urlConfigs.length) {
      return false;
    }
    this.url.set(`${this.urlConfigs[this.urlId()].base_url}/${this.cancellationId()}${this.urlConfigs[this.urlId()].ext}`);
    this.urlId.set(this.urlId() + 1);
    return true;
  }

  updateUrl() {
    if (!this.buildUrl()) {
      this.hasKioskPhoto.emit(false);
      this.imageNotFound.set(true);
    }
  }

  imageFinishedLoading() {
    this.hasKioskPhoto.emit(true);
    this.imageLoaded.set(true);
  }

  getImageDisplayState() {
    if (!this.imageLoaded() && !this.imageNotFound()) {
      return 'none';
    } else {
      return 'block';
    }
  }
}

export async function resolveKioskPhotoUrl(imageId: string): Promise<string | undefined> {
  const urls = environment.suspectImageUrlConfigs.map((c) => `${c.base_url}/${imageId}${c.ext}`);
  for (const url of urls) {
    try {
      const found = await new Promise<boolean>((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
      });
      if (found) {
        return url;
      }
    } catch (e) {
      console.error('Error checking image URL:', e);
    }
  }
  return undefined;
}
